import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AdminPanel from "./AdminPanel";
import Login from "./Login";
import LecturerDashboard from "./LecturerDashboard";
import ForgotPassword from "./ForgotPassword";
import StudentDashboard from "./StudentDashboard";
import PrivateRoute from "./PrivateRoute";
import { auth, db } from "./firebase";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { ToastContainer } from "react-toastify";
import CreateStudentDashboard from "./create-student-dashboard";

import CPDPanel from "./cpd-panel";
import AdminPanelD from "./AdminPanel-D";
import AdminPanelT from "./AdminPanel-T";
import SupervisionAdminPanel from "./supervision-admin-panel";



const App = () => {
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const userDoc = await getDoc(doc(db, "users", user.uid));
        if (userDoc.exists()) {
          setUserRole(userDoc.data().role);
        }
      } else {
        setUserRole(null);
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <Router>
           <ToastContainer />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/ForgotPassword" element={<ForgotPassword/>} />
        {/* <Route path="/AdminPanel" element={<AdminPanel />} /> */}
   
        <Route
          path="/AdminPanel"
          element={
            <PrivateRoute role="admin" userRole={userRole}>
              <AdminPanel />
            </PrivateRoute>
          }
        />

`


        <Route
          path="/supervision-admin-panel" 
          element={
            <PrivateRoute role="supervisionadmin" userRole={userRole}>
              <SupervisionAdminPanel />
            </PrivateRoute>
          }
        />





        <Route
          path="/AdminPanel-D"
          element={
            <PrivateRoute role="admin-d" userRole={userRole}>
              <AdminPanelD />
            </PrivateRoute>
          }
        />


                <Route
          path="/AdminPanel-T"
          element={
            <PrivateRoute role="admin-t" userRole={userRole}>
              <AdminPanelT />
            </PrivateRoute>
          }
        />


        <Route
          path="/create-student-dashboard"
          element={
            <PrivateRoute role="sub-admin" userRole={userRole}>
              <CreateStudentDashboard />
            </PrivateRoute>
          }
        />



        <Route
          path="/LecturerDashboard"
          element={
            <PrivateRoute role="lecturer" userRole={userRole}>
              <LecturerDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/StudentDashboard"
          element={
            <PrivateRoute role="student" userRole={userRole}>
              <StudentDashboard />
            </PrivateRoute>
          }
        />



        <Route
          path="/cpd-panel"
          element={
            <PrivateRoute role="oldstudent" userRole={userRole}>
              <CPDPanel />
            </PrivateRoute>
          }
        />






      </Routes>
   
    </Router>

    
  );
};

export default App;
